
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Profile, WebsiteProfileDisplayType } from 'client-website-ts-library/types/Profile';

@Component
export default class ProfileCard extends Vue {
  @Prop()
  private readonly profile!: Profile;

  getAgentPostion(): string {
    if (this.profile === null) return '';
    let displayType: string;
    console.log(this.profile.FullName);
    switch (this.profile.DisplayType) {
      case WebsiteProfileDisplayType.Agent:
        displayType = 'Agent';
        break;
      case WebsiteProfileDisplayType.PersonalAssistant:
        displayType = 'Assistant';
        break;
      case WebsiteProfileDisplayType.PropertyManager:
        displayType = 'PM';
        break;
      case WebsiteProfileDisplayType.CommercialAgent:
        displayType = 'Agent';
        break;
      case WebsiteProfileDisplayType.Principal:
        displayType = 'Principal';
        break;
      default:
        displayType = 'Agent';
        break;
    }

    return displayType;
  }
}
